module.exports = __webpack_public_path__ + "media/images/sp/top/recommend-plan-maedori1-6d9e3cc8bb6f87133e596727bbc2b189.jpg";